import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, input, signal } from '@angular/core';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { IconModule } from 'ish-core/icon.module';

@Component({
  selector: 'ish-accordion-item',
  templateUrl: './accordion-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgbCollapseModule, IconModule],
})
export class AccordionItemComponent implements OnChanges {
  readonly heading = input<string>(undefined);
  readonly dataTestingId = input<string>(undefined);
  readonly isCollapsed = input<boolean>(false);
  isCollapsedChange = signal<boolean>(false);

  ngOnChanges() {
    this.isCollapsedChange.set(this.isCollapsed());
  }

  toggleCollapse() {
    this.isCollapsedChange.set(!this.isCollapsedChange());
    // eslint-disable-next-line ish-custom-rules/no-assignment-to-inputs
    // this.isCollapsedChange.emit(!this.isCollapsed());
  }
}
